/**
 * Date helpers for the admin panel.
 *
 * All "what day is it" logic reads the browser's local calendar with component
 * accessors (getFullYear / getMonth / getDate). toISOString() renders UTC and
 * lags the local date for 1 to 2 hours after every local midnight in Croatia.
 */

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/** Format a Date as YYYY-MM-DD in local time. */
export function toLocalDateStr(d: Date): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Today's date as YYYY-MM-DD in local time. */
export function todayStr(): string {
  return toLocalDateStr(new Date());
}

/** True when the string is a real calendar date written as YYYY-MM-DD. */
export function isValidDateStr(value: string): boolean {
  if (!DATE_PATTERN.test(value)) {
    return false;
  }
  const [year, month, day] = value.split('-').map(Number);
  const d = new Date(year, month - 1, day);
  return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day;
}

/** Shift a YYYY-MM-DD string by a number of days (negative for the past). */
export function addDays(dateStr: string, days: number): string {
  const [year, month, day] = dateStr.split('-').map(Number);
  const d = new Date(year, month - 1, day + days);
  return toLocalDateStr(d);
}
